import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import ModalConvocatoria from '../Modal/ModalConvocatoria';
import { FacebookProvider, Page } from 'react-facebook';
import './inicio.css';
//import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';

const Inicio = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  
  // 1. DECLARAMOS EL ESTADO PARA EL CARRUSEL DE NOTICIAS
  const [currentNotice, setCurrentNotice] = useState(0);

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 2. TEMPORIZADOR AUTOMÁTICO (Rota cada 5 segundos)
  // Funciones para avanzar y retroceder manualmente
  const nextSlide = () => {
    setCurrentNotice((prevIndex) =>
      prevIndex === window._my_ultimasNoticias.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentNotice((prevIndex) =>
      prevIndex === 0 ? window._my_ultimasNoticias.length - 1 : prevIndex - 1
    );
  };
  useEffect(() => {
    if (window._my_ultimasNoticias && window._my_ultimasNoticias.length > 1) {
      const interval = setInterval(() => {
        setCurrentNotice((prevIndex) => 
          prevIndex === window._my_ultimasNoticias.length - 1 ? 0 : prevIndex + 1
        );
      }, 7000); // 5000ms = 5 segundos

      return () => clearInterval(interval);
    }
  }, []);

  return (
    <>
      <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} />
      <Carousel/>
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("${window._my_icono}")` }}></div>
          </div>
          <div className='secretaria_name'>
            <h1>{window._my_secretaria}</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <div><div dangerouslySetInnerHTML={{ __html: window._my_funciones }}/></div>
            <div className='btn_organigrama'>
              <Link to="Transparencia/Rubros/DetalleRubro/2.Estructura"><button type="button" className="btn btn-primary">Organigrama</button></Link>
              <Link to="Transparencia/Rubros/DetalleRubro/1.Normatividad"><button type="button" className="btn btn-primary">Normatividad</button></Link>
              <Link to="Comites"><button type="button" className="btn btn-primary">Comités</button></Link>
            </div>
            {
              window._my_redes && window._my_redes.length > 0 ?
                <div className='secretaria-redes'>
                  {
                    window._my_redes.map((item, i) => 
                      <a href={item.link} target="_new" key={i}><i className={item.class}></i></a>
                    )
                  }
                </div>
              : null
            }
          </div>
        </div>

        <div className='row'>
            <div>
                <h3 className='title'>Indicadores</h3>
                <hr className='hr-gob'/>
            </div>
            <div className="flex_indicadores">
            {
              window._my_indicadores && window._my_indicadores.map((item, index)=>(
                <div key={ index } className='de_indicadores'>
                    <div>{item.total}</div>
                    {item.nombre}
                </div>
              ))
            }
            </div>
        </div>

        {/* SECCIÓN CORREGIDA DE ÚLTIMAS NOTICIAS (CARRUSEL GRANDE) */}
        {/* SECCIÓN DE ÚLTIMAS NOTICIAS CON FLECHAS DE NAVEGACIÓN */}
        <div id='ultimas_noticias' style={{ width: '100%', padding: '40px 0', backgroundColor: '#fcfcfc' }}>
          <div className='row' style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
            <div className='notice_section' style={{ width: '100%' }}>
              <div className='notice_title'>
                <h3 className='title'>ÚLTIMAS NOTICIAS</h3>
                <hr className='hr-gob'/>
              </div>

              {/* Contenedor relativo para posicionar las flechas sobre el banner */}
              <div className="carousel_container_rel" style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', maxWidth: '1050px', margin: '30px auto 0 auto' }}>
                
                {/* Mostrar controles de navegación solo si hay más de 1 banner */}
                {window._my_ultimasNoticias && window._my_ultimasNoticias.length > 1 && (
                  <>
                    <button 
                      onClick={prevSlide} 
                      style={{ position: 'absolute', left: '15px', zIndex: 10, background: 'rgba(0,0,0,0.4)', color: '#fff', border: 'none', borderRadius: '50%', width: '45px', height: '45px', cursor: 'pointer', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.3)', transition: 'background 0.3s' }}
                      onMouseOver={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.7)'}
                      onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.4)'}
                    >
                      &#10094; {/* Flecha Izquierda */}
                    </button>
                    
                    <button 
                      onClick={nextSlide} 
                      style={{ position: 'absolute', right: '15px', zIndex: 10, background: 'rgba(0,0,0,0.4)', color: '#fff', border: 'none', borderRadius: '50%', width: '45px', height: '45px', cursor: 'pointer', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.3)', transition: 'background 0.3s' }}
                      onMouseOver={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.7)'}
                      onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.4)'}
                    >
                      &#10095; {/* Flecha Derecha */}
                    </button>
                  </>
                )}

                <div className="carousel_noticias" style={{ width: '100%', overflow: 'hidden' }}>
                  {
                    window._my_ultimasNoticias && window._my_ultimasNoticias.length > 0 ? (
                      <div className="tarjeta_noticia" style={{ width: '100%', textAlign: 'center' }}>
                        <a href={window._my_ultimasNoticias[currentNotice].url} target="_blank" rel="noopener noreferrer">
                          <img 
                            src={window._my_ultimasNoticias[currentNotice].imagen} 
                            alt={window._my_ultimasNoticias[currentNotice].titulo} 
                            title={window._my_ultimasNoticias[currentNotice].titulo} 
                            style={{ 
                            width: '100%', 
                            height: '350px', // <-- Forzamos una altura fija para todos los banners
                            objectFit: 'cover', // <-- Evita que la imagen se estire o se deforme
                            objectPosition: 'center', // <-- Centra el recorte de la imagen
                            borderRadius: '6px', 
                            boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                            animation: 'fadeInCarousel 0.8s ease-in-out'
                            }} 
                          />
                        </a>
                      </div>
                    ) : (
                      <p>No hay noticias disponibles en este momento.</p>
                    )
                  }
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob'/>
          </div>
          <div className='section_notes'>
            {
              window._my_titular && window._my_titular.map((item, index) =>(
                  <React.Fragment key={ index }>
                    <div className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función del Secretario</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda del Secretario</Link>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
              ))
            }
          </div>
        </div>

        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob'/>
            </div>
            <iframe src={window._my_ubicacion}
              width="100%" 
              height="300" 
              frameBorder="0"
              title="Ubicación"
              style={{border:0, marginBottom:50}} 
              allowFullScreen>
            </iframe >
          </div>
        </div>   
      </div>
    </>
  )
}

export default Inicio;